import styled from 'styled-components';
import emptyContentUrl from '~/assets/img/work-in-progress.png';

const WipContent = () => (
  <S.Container>
    <S.Image src={emptyContentUrl} />
    <S.Caption>Page under construction</S.Caption>
  </S.Container>
);

const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  `,
  Image: styled.img`
    width: 150px;
    height: auto;
  `,
  Caption: styled.h2`
    font-weight: 400;
    margin-bottom: 2rem;
  `,
};

export default WipContent;
